var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2664_107159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.49337 0 0 3.30113 0 7.76C0 10.0923 0.955813 12.1076 2.5125 13.4997C2.64313 13.6166 2.722 13.7805 2.72738 13.9558L2.77094 15.3789C2.78487 15.8328 3.25369 16.1282 3.66906 15.9448L5.25694 15.2437C5.39152 15.1844 5.54246 15.1734 5.68425 15.2124C6.41394 15.4131 7.1905 15.5199 8 15.5199C12.5066 15.5199 16 12.2188 16 7.75994C16 3.30106 12.5066 0 8 0Z",
    fill: "url(#paint0_radial_2664_107159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19655 10.0294L5.54655 6.3011C5.9203 5.70797 6.7208 5.56029 7.28167 5.98091L9.15073 7.38279C9.2342 7.44539 9.3358 7.47909 9.44014 7.47879C9.54448 7.47849 9.64588 7.44419 9.72898 7.3811L12.2532 5.46535C12.5901 5.20966 13.03 5.61285 12.8045 5.97066L10.4545 9.69904C10.0807 10.2921 9.28011 10.4398 8.7193 10.0192L6.85017 8.61729C6.76671 8.55471 6.66514 8.52103 6.56083 8.52133C6.45651 8.52164 6.35514 8.55591 6.27205 8.61897L3.74767 10.5347C3.4108 10.7903 2.97098 10.3872 3.19655 10.0294Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2664_107159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.07952 15.9144) scale(17.4336 17.4336)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60975,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93482,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2664_107159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.bedc13f8d6a563955613a14911bb3a0d.svg";
export { ForwardRef as ReactComponent };